/* eslint no-console:0 */

import 'css/landing';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

import Rails from '@rails/ujs';

Rails.start();
